import type { FieldErrors } from '../api/errors';
import { selectCustomFields, selectParagraph, selectSubmitLabel } from '../state/selectors';
import { useEnv, useFormState } from './context';
import { CustomFields } from './CustomFields';
import { DiscountCode } from './DiscountCode';
import { Html } from './Html';
import { Payment } from './Payment';

interface Props {
  errors: FieldErrors;
}

/** Step 3 — billing: gift card, payment method and card, captcha, and the before-submit fields. */
export function Step3({ errors }: Props) {
  const state = useFormState();
  const { beforeSubmit } = selectCustomFields(state);
  const agreement = selectParagraph(state, 'agreement_information');
  return (
    <>
      <DiscountCode errors={errors} />
      <Payment errors={errors} />
      {beforeSubmit.length ? (
        <section className="cbf-card" aria-label="Before you book">
          <CustomFields fields={beforeSubmit} errors={errors} />
        </section>
      ) : null}
      {agreement ? <Html as="p" className="cbf-help" html={agreement} /> : null}
    </>
  );
}

const PHASE_TEXT: Record<string, string> = {
  validating: 'Checking your details…',
  recaptcha: 'Checking your details…',
  setup_intent: 'Securing your card…',
  confirm_card: 'Verifying your card…',
  posting: 'Booking your appointment…',
};

export function SubmitButton({ block = false }: { block?: boolean }) {
  const { controller } = useEnv();
  const state = useFormState();
  const submitting = state.status === 'submitting';
  return (
    <button type="button" className={`cbf-btn${block ? ' cbf-btn-block' : ''}`} onClick={() => void controller.submit()} disabled={submitting} aria-busy={submitting || undefined}>
      {submitting ? PHASE_TEXT[state.submitPhase] ?? 'Booking…' : selectSubmitLabel(state)}
    </button>
  );
}
